import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1da44063&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1da44063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da44063",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutHeaderBack: require('/codebuild/output/src2055422172/src/med-el-hearpeers/components/Layout/HeaderBack.vue').default,Profile: require('/codebuild/output/src2055422172/src/med-el-hearpeers/components/Profile/index.vue').default,ProfileModern: require('/codebuild/output/src2055422172/src/med-el-hearpeers/components/ProfileModern/index.vue').default,UiAside: require('/codebuild/output/src2055422172/src/med-el-hearpeers/components/Ui/Aside.vue').default,UiAvatar: require('/codebuild/output/src2055422172/src/med-el-hearpeers/components/Ui/Avatar.vue').default,UiButton: require('/codebuild/output/src2055422172/src/med-el-hearpeers/components/Ui/Button/index.vue').default,UiFlag: require('/codebuild/output/src2055422172/src/med-el-hearpeers/components/Ui/Flag.vue').default,PageMentorsBreaker: require('/codebuild/output/src2055422172/src/med-el-hearpeers/components/Page/MentorsBreaker.vue').default,PageMentorsRelated: require('/codebuild/output/src2055422172/src/med-el-hearpeers/components/Page/MentorsRelated.vue').default})
